// ----------------------------------------------------------------------
// <copyright file="Izenda.SaveWorkspacePopupAction.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!(function () {
  var compose = require('recompose').compose;
  var withState = require('recompose').withState;
  var withHandlers = require('recompose').withHandlers;
  const {curry, isBoolean, isEmpty} = require('lodash/fp');

  var saveWorkspacePopupAction = compose(
    withState('workspaceName', 'setWorkspaceName', function (props) {
      return props.store.item.name;
    }),
    withHandlers({
      onClosing: curry(onClosing),
      updateWorkspaceName:  curry(updateWorkspaceName),
      onChangeOwner:  curry(onChangeOwner),
      updateWorkspaceDescription:  curry(updateWorkspaceDescription)
    })
  );

  /**
   * on closing pop up save work space
   */
  function onClosing(props, closeCallback, type) {
    var valManager = props.validation;
    var loader = props.loader;
    var item = props.store.item;

    if (type === 'accept') {
      valManager.validate(['Name', 'ownerList'])
        .then(function(success){
          if (success) {
            item.updateWorkspaceName(props.workspaceName);
            onSave(props);
          }
      });
    } else if (type === 'cancel') {
      props.onReject();
    }
  };

  /**
   * handle onSave
   * @return {promise}
   */
  function onSave(props) {
    var loader = props.loader;

    loader.startLoading();
    props.onClosing(props.isSaveAs)
      .then(function (result) {
         isBoolean(result) && result
          ? props.onAccept()
          : handleError(props, result);
        return result;
      })
      .finally(loader.endLoading.bind(loader));
  };

  /**
   * handle Error
   * @param  {object} result
   */
  function handleError(props, result) {
    var loader = props.loader;
    var valManager = props.validation;

    if (! isEmpty(result.messages) &&  isEmpty(result.messages[0].key)) {
      return props.confirmFn('Confirmation', {
        description: result.messages[0].messages[0],
        showCancel: false
      }).then(function () {
        loader.startLoading();
        props.onReject();
        props.store.handleAfterConcurrency(result.messages[0].detail)
                   .finally(loader.endLoading.bind(loader));
      });
    } else {
      valManager.updateErrors(result.messages);
      return null;
    }
  };

  /**
   * update Workspace Name
   * @param  {object} props
   * @param  {string} name
   */
  function updateWorkspaceName(props, name) {
    props.store.item.updateWorkspaceName(name);
  };

  /**
   * onChange Owner
   * @param  {object} props
   * @param  {object} ownerId
   */
  function onChangeOwner(props, ownerId) {
    props.store.item.updateOwnerList(ownerId);
  };

  /**
   * update Workspace Description
   * @param  {object} props
   * @param  {string} desc
   */
  function updateWorkspaceDescription(props, desc) {
    props.store.item.updateWorkspaceDescription(desc);
  };

  module.exports = saveWorkspacePopupAction;
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/ActionBar/Izenda.SaveWorkspacePopupAction.js